import { InjectionToken } from "@angular/core";

export const LOCALE = new InjectionToken<string>("Locale used for datetime module things");
